(function () {
  let currentSlider = null;
  let debounceTimer = null;

  function destroySlider() {
    if (currentSlider) {
      try {
        currentSlider.destroy();
      } catch (e) {
        // instance was already gone / DOM detached — ignore
      }
      currentSlider = null;
    }
  }

  function initPromotionSlider() {
    destroySlider();

    const sliderContainer = document.querySelector('li.custom-promotion-slider');
    if (!sliderContainer) return;

    // Wipe any leftover arrows/dots so they don't stack on repeated init
    sliderContainer.querySelectorAll('.keen-slider__arrow').forEach((el) => el.remove());
    const maybeDots = sliderContainer.nextElementSibling;
    if (maybeDots && maybeDots.classList.contains('keen-slider__dots')) {
      maybeDots.remove();
    }

    sliderContainer.classList.add('keen-slider');
    sliderContainer.querySelectorAll('.custom-block-add').forEach((el) => {
      el.classList.add('keen-slider__slide');
    });

    currentSlider = new KeenSlider(sliderContainer, {
      slides: { perView: 1 },
      loop: true,
    });

    const prevBtn = document.createElement('button');
    prevBtn.className = 'keen-slider__arrow keen-slider__arrow--left';
    prevBtn.innerHTML = '<svg width="15" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="m6.797 11.625 8.03-8.03 1.06 1.06-6.97 6.97 6.97 6.97-1.06 1.06z"></path></svg>';
    prevBtn.addEventListener('click', () => currentSlider && currentSlider.prev());

    const nextBtn = document.createElement('button');
    nextBtn.className = 'keen-slider__arrow keen-slider__arrow--right';
    nextBtn.innerHTML = '<svg width="15" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="m9.693 4.5 7.5 7.5-7.5 7.5" stroke="currentColor" stroke-width="1.5" fill="none"></path></svg>';
    nextBtn.addEventListener('click', () => currentSlider && currentSlider.next());

    sliderContainer.appendChild(prevBtn);
    sliderContainer.appendChild(nextBtn);

    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'keen-slider__dots';
    currentSlider.track.details.slides.forEach((_, idx) => {
      const dot = document.createElement('button');
      dot.className = 'keen-slider__dot';
      dot.addEventListener('click', () => currentSlider && currentSlider.moveToIdx(idx));
      dotsContainer.appendChild(dot);
    });
    sliderContainer.after(dotsContainer);

    currentSlider.on('slideChanged', (s) => {
      dotsContainer.querySelectorAll('.keen-slider__dot').forEach((dot, idx) => {
        dot.classList.toggle('keen-slider__dot--active', s.track.details.rel === idx);
      });
    });
  }

  function scheduleInit() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(initPromotionSlider, 50);
  }

  // Normal page load
  document.addEventListener('DOMContentLoaded', initPromotionSlider);

  // Theme's own event (kept as a fast-path trigger)
  document.addEventListener('on:facet-filters:updated', scheduleInit);

  // Filter button click — re-init after the filter UI updates the DOM
  document.addEventListener('click', (e) => {
    if (e.target.closest('.products-toolbar__filter-btn')) {
      scheduleInit();
    }
  });

  // Fallback: watch #filter-results for ANY markup swap and re-init if the
  // slider element re-appears but has no live instance attached to it
  const resultsEl = document.getElementById('filter-results');
  if (resultsEl && window.MutationObserver) {
    const observer = new MutationObserver(() => {
      if (document.querySelector('li.custom-promotion-slider') && !currentSlider) {
        scheduleInit();
      }
    });
    observer.observe(resultsEl, { childList: true, subtree: true });
  }
})();





// document.addEventListener("DOMContentLoaded", function () {
//   const sliderContainer = document.querySelector("li.custom-promotion-slider");
//   if (sliderContainer) {
//     sliderContainer.classList.add("keen-slider");
//     sliderContainer.querySelectorAll(".custom-block-add").forEach(el => {
//       el.classList.add("keen-slider__slide");
//     });

//     let slider = new KeenSlider(sliderContainer, {
//       slides: { perView: 1 },
//       loop: true,
//     });

//     // Arrows
//     const prevBtn = document.createElement("button");
//     prevBtn.className = "keen-slider__arrow keen-slider__arrow--left";
//     prevBtn.innerHTML = '<svg width="15" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="m6.797 11.625 8.03-8.03 1.06 1.06-6.97 6.97 6.97 6.97-1.06 1.06z"></path></svg>';
//     prevBtn.addEventListener("click", () => slider.prev());

//     const nextBtn = document.createElement("button");
//     nextBtn.className = "keen-slider__arrow keen-slider__arrow--right";
//     nextBtn.innerHTML = '<svg width="15" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="m9.693 4.5 7.5 7.5-7.5 7.5" stroke="currentColor" stroke-width="1.5" fill="none"></path></svg>';
//     nextBtn.addEventListener("click", () => slider.next());

//     sliderContainer.appendChild(prevBtn);
//     sliderContainer.appendChild(nextBtn);

//     // Dots
//     const dotsContainer = document.createElement("div");
//     dotsContainer.className = "keen-slider__dots";
//     slider.track.details.slides.forEach((_, idx) => {
//       const dot = document.createElement("button");
//       dot.className = "keen-slider__dot";
//       dot.addEventListener("click", () => slider.moveToIdx(idx));
//       dotsContainer.appendChild(dot);
//     });
//     sliderContainer.after(dotsContainer);

//     slider.on("slideChanged", (s) => {
//       const dots = dotsContainer.querySelectorAll(".keen-slider__dot");
//       dots.forEach((dot, idx) => {
//         dot.classList.toggle("keen-slider__dot--active", s.track.details.rel === idx);
//       });
//     });
//   }
// });
